__turbopack_context__.v({
  "link": "LegacyBrandBanner-module__bby7kW__link",
  "skeleton": "LegacyBrandBanner-module__bby7kW__skeleton",
  "skeletonIcon": "LegacyBrandBanner-module__bby7kW__skeletonIcon",
  "skeletonMessage": "LegacyBrandBanner-module__bby7kW__skeletonMessage",
});
